import { useEffect, useRef, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Button, Card, Col, Form, Image, Input, Row, Spin, Upload } from 'antd';

import { handlePostApi } from '@/api/crud';

import { companyApiEndpoints } from '@/api/endpoints';
import { rules } from '@/utils/validation/FormValidation';

import GlobalDivider from '@/utils/divider/GlobalDivider';
import { AntButton } from '@/common/ant-components/AntButton';

const CreateCompany = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm(); //Form hooks for managing hooks state

  const navigate = useNavigate();
  const backRef = useRef();
  const createRef = useRef();

  useEffect(() => {
    form.getFieldInstance('name').focus();
  }, []);
  return (
    <>
      <section className="">
        <Card>
          <Form
            labelCol={{
              span: 12,
            }}
            wrapperCol={{
              span: 24,
            }}
            form={form}
            size="middle"
            className="username"
            onFinish={async (value) => {
              // const photo = await imageToBase64(value.photo);

              await handlePostApi(
                companyApiEndpoints.create,
                {
                  ...value,
                  // photo: photo ? photo : null,
                  financialYearStart: value?.financialStart,
                  financialYearEnd: value?.financialEnd,
                },
                setLoading,
                form,
                form.resetFields(),
              );
            }}
            layout="vertical"
          >
            <Spin spinning={loading}>
              <GlobalDivider name="Create Company" />

              <Row gutter={[16, 16]}>
                <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                  <Form.Item
                    label="Company Name"
                    name="name"
                    // rules={rules.textOnly}
                    // rules={rules.textAndNumberOnly}
                    rules={rules.required}
                    hasFeedback
                    validateTrigger="onChange"
                  >
                    <Input
                      onKeyDown={(e) => {
                        if (e.code === 'Tab' && e.shiftKey) {
                          e.preventDefault();
                          backRef.current.focus();
                        }
                      }}
                      placeholder="Company Name"
                      autoComplete="off"
                    />
                  </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                  <Form.Item
                    label="Address"
                    name="address"
                    hasFeedback
                    rules={rules.required}
                    validateTrigger="onChange"
                  >
                    <Input autoComplete="off" placeholder="Address" />
                  </Form.Item>
                </Col>
                {/* <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                  <Form.Item
                    label="Pan/Vat No"
                    name="panVat"
                    rules={rules.panVat}
                    hasFeedback
                    validateTrigger="onChange"
                  >
                    <Input
                      autoComplete="off"
                      placeholder="XXXXXXXXXX"
                      maxLength={9}
                    />
                  </Form.Item>
                </Col> */}
              </Row>

              {/* <Row gutter={24}> */}
              {/*<Col xs={{ span: 24 }} lg={{ span: 8 }}>
                  <Form.Item
                    hasFeedback
                    label="Financial Year Start"
                    name="financialStartYear" // financialYearStart financialYearEnd
                    rules={rules.Date}
                  >
                    <Date />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                  <Form.Item
                    hasFeedback
                    label="Financial Year End"
                    name="financialEndYear" // financialYearStart financialYearEnd
                    rules={rules.Date}
                  >
                    <Date />
                  </Form.Item>
                </Col>*/}
              {/* <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={rules.email}
                    validateTrigger="onChange"
                    hasFeedback
                  >
                    <Input
                      autoComplete="off"
                      placeholder="example@domin.com"
                      type="email"
                    />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                  <Form.Item
                    label="Mobile"
                    name="mobileNumber"
                    rules={rules.phoneNumber}
                    validateTrigger="onChange"
                    hasFeedback
                  >
                    <Input
                      autoComplete="off"
                      placeholder="98XXXXXXX"
                      maxLength={10}
                    />
                  </Form.Item>
                </Col> */}
              {/* </Row> */}

              {/* <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  className="username text-start"
                  label="Company Profile"
                  name="photo"
                  valuePropName="file"
                  getValueFromEvent={normFile}
                >
                  <Upload
                    listType="picture-card"
                    accept=".jpg, .jpeg, .png, .gif"
                    // fileList={fileList}
                    onChange={onChange}
                    onPreview={(file) =>
                      onPreview(file, setPreviewImage, setPreviewOpen)
                    }
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {fileList.length < 5 && '+ Upload'}
                  </Upload>
                </Form.Item>

                {previewImage && (
                  <Image
                    wrapperStyle={{ display: 'none' }}
                    preview={{
                      visible: previewOpen,
                      onVisibleChange: (visible) => setPreviewOpen(visible),
                      afterOpenChange: (visible) =>
                        !visible && setPreviewImage(''),
                    }}
                    src={previewImage}
                  />
                )}
              </Col> */}

              <div className="flex justify-end">
                <div className="flex gap-2">
                  <AntButton
                    ref={createRef}
                    className="submit-button"
                    htmlType="submit"
                  >
                    Create
                  </AntButton>

                  <AntButton
                    color="red"
                    className="auto-danger-btn"
                    ref={backRef}
                    onClick={() => navigate(-1)}
                    onKeyDown={(e) => {
                      if (e.code === 'Tab' && e.shiftKey) {
                        e.preventDefault();
                        createRef.current.focus();
                        return;
                      }
                      if (e.code === 'Tab') {
                        e.preventDefault();
                        form.getFieldInstance('name').focus();
                      }
                    }}
                  >
                    Back
                  </AntButton>
                </div>
              </div>
            </Spin>
          </Form>
        </Card>
      </section>
    </>
  );
};

export default CreateCompany;
